/**
 * このIDはdatadogなどのログ収集サービスと紐づけるためのものであり、厳密なランダム性は求めない。
 */
export const getRandomId = () => Math.floor(20e6 * Math.random()).toString(16);
